export function getToggleBackgroundColor(isActive, disabled) {
  if (isActive) {
    return 'lightPrimary';
  }
  if (disabled && !isActive) {
    return 'lightGray';
  }
  return 'white';
}

export function getToggleBorderColor(isActive) {
  if (isActive) {
    return 'lightPrimary';
  }
  return 'gray';
}

export function getTogglerBackgroundColor(isActive, disabled) {
  if (isActive && disabled) {
    return 'primary';
  }
  if (isActive && !disabled) {
    return 'primary';
  }
  if (!isActive && disabled) {
    return 'grayText';
  }
  return 'blackText';
}
